const _ = require('lodash');
const General = require('./he/General.json');
const ConfirmationPage = require('./he/ConfirmationPage.json');
const Grid = require('./he/Grid.json');
const HotelPage = require('./he/HotelPage.json');
const ManagementPage = require('./he/ManagementPage.json');
const ManagementReportsPage = require('./he/ManagementReportsPage.json');
const NewBookingsPage = require('./he/NewBookingsPage.json');
const ReportsCFOMock = require('./he/ReportsCFOMock.json');
const ReportsPage = require('./he/ReportsPage.json');
const RequestPage = require('./he/RequestPage.json');
const ReservationPaymentPage = require('./he/ReservationPaymentPage.json');
const ResultsPage = require('./he/ResultsPage.json');
const SearchPage = require('./he/SearchPage.json');
const TravelPolicyPage = require('./he/TravelPolicyPage.json');
const UsersManagementPage = require('./he/UsersManagementPage.json');
const AboutUs = require('./he/AboutUs.json');
const ContactPage = require('./he/ContactPage.json');
const Elal = require('./he/Elal.json')
const CreditLinePage = require('./he/CreditLinePage.json');
const CashWallet = require('./he/CashWallet.json');

module.exports = {
	CashWallet,
	translation: _.merge(
		{},
		General,
		ConfirmationPage,
		Grid,
		HotelPage,
		ManagementPage,
		ManagementReportsPage,
		NewBookingsPage,
		ReportsCFOMock,
		ReportsPage,
		RequestPage,
		ReservationPaymentPage,
		ResultsPage,
		SearchPage,
		TravelPolicyPage,
		UsersManagementPage,
		AboutUs,
		ContactPage,
		Elal,
		CreditLinePage,
	),
};
